export const isSafari =
  typeof navigator !== 'undefined' &&
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);



export const formatUrl = (path) => {
    if (!path) return '/';
    // Remove any leading slashes and ensure single leading slash
    return '/' + path.replace(/^\/+/, '');
};


      // Helper function to check iterability
      export function isIterable(obj) {
        return obj != null && typeof obj[Symbol.iterator] === 'function';
      }
      export const formatDate = (dateString) => {
        if (!dateString) return ""
        const date = new Date(dateString)
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
      }

/**
 * Safe requestIdleCallback with fallback for browsers that don't support it
 * @param {Function} callback - Function to execute when idle
 * @param {Object} options - Options object with timeout
 * @returns {number} - ID for cancellation
 */
export const safeRequestIdleCallback = (callback, options = {}) => {
    if (typeof window === 'undefined') {
        // Server-side rendering - execute immediately
        return setTimeout(callback, 0);
    }
    
    if (window.requestIdleCallback) {
        return window.requestIdleCallback(callback, options);
    } else {
        // Fallback for browsers that don't support requestIdleCallback
        const timeout = options.timeout || 50;
        return setTimeout(callback, timeout);
    }
};
